import { darkThemeStyles, JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { TextField } from '@material-ui/core';
import { StandardTextFieldProps } from '@material-ui/core/TextField';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    ...darkThemeStyles,
    white: { color: theme.palette.common.white },
  })
);

const AccountPageTextField = ({ ...props }: StandardTextFieldProps) => {
  const classes = useStyles();

  return (
    <TextField
      InputLabelProps={{
        className: clsx(classes.textInputLabel, classes.white),
        classes: {
          disabled: classes.textInputLabelDisabled,
          focused: clsx(classes.textInputLabelFocused, classes.white),
        },
      }}
      InputProps={{
        className: clsx(classes.white, classes.textInput),
        classes: {
          disabled: classes.disabled,
          underline: classes.textFieldUnderline,
        },
      }}
      FormHelperTextProps={{
        className: clsx(classes.helperText, classes.white),
        classes: {
          disabled: classes.disabledHelpText,
        },
      }}
      margin="normal"
      fullWidth={true}
      {...props}
    />
  );
};

export default AccountPageTextField;
